import React from "react";

export const tableColumns = [
  {
    name: "",
    label: "No",
    options: {
      customBodyRender: (_, tableMeta) => {
        const { page, rowsPerPage } = tableMeta.tableState;
        const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

        return <>{rowNumber}</>;
      },
      sort: false,
    },
  },
  {
    name: "salesInvoiceDate",
    label: "Tgl FJ",
  },
  {
    name: "salesInvoiceNumber",
    label: "No. FJ",
  },
  {
    name: "customerName",
    label: "Nama Pembeli",
  },
  {
    name: "customerStnkName",
    label: "Nama STNK",
  },
  {
    name: "dataVariant.kodeVariant",
    label: "Kode Varian",
  },
  {
    name: "dataVariant.namaVariant",
    label: "Nama Varian",
  },
  {
    name: "dataWarna.kodeWarna",
    label: "Kode Warna",
  },
  {
    name: "dataWarna.namaWarnaKomersil",
    label: "Nama Warna",
  },
];
